// extracted by mini-css-extract-plugin
module.exports = {"theme":"#13ce66"};